import { ISafetyCaseHazardValues } from './safety-case-hazard-form-types'
import {
  IGeoJson,
  ISafetyCaseHazard,
  ISafetyCaseHazardUpdateUpsert,
  ISafetyCaseHazardAddUpsert,
} from '../../../../interfaces'

export const safetyCaseHazardToSafetyCaseHazardValues = (
  hazard: ISafetyCaseHazard | undefined,
): ISafetyCaseHazardValues | undefined => {
  if (!hazard) {
    return undefined
  }

  return {
    name: hazard?.name,
    description: hazard?.description,
    selectedRiskMatrixCell: hazard?.selectedRiskMatrixCell,
    riskMatrixRationale: hazard?.riskRationale,
    sortOrder: String(hazard?.sortOrder),
  }
}

export const safetyCaseHazardValuesToSafetyCaseHazardAddUpsert = (
  safetyCaseHazardValues: ISafetyCaseHazardValues,
  payload: { safetyCaseId: number; geoJson?: IGeoJson },
): ISafetyCaseHazardAddUpsert | undefined => {
  if (!safetyCaseHazardValues) {
    return undefined
  }

  return {
    safetyCaseId: payload.safetyCaseId,
    name: safetyCaseHazardValues?.name,
    description: safetyCaseHazardValues?.description,
    selectedRiskMatrixCellId: safetyCaseHazardValues?.selectedRiskMatrixCell?.id,
    riskRationale: safetyCaseHazardValues?.riskMatrixRationale,
    geometry: payload?.geoJson && {
      type: String(payload.geoJson.geometry.type),
      coordinates: JSON.stringify(payload.geoJson.geometry.coordinates),
    },
    sortOrder: safetyCaseHazardValues?.sortOrder,
  }
}

export const safetyCaseHazardValuesToSafetyCaseHazardUpdateUpsert = (
  safetyCaseHazardValues: ISafetyCaseHazardValues,
  payload: { safetyCaseHazard: ISafetyCaseHazard; geoJson?: IGeoJson },
): ISafetyCaseHazardUpdateUpsert | undefined => {
  if (!safetyCaseHazardValues) {
    return undefined
  }

  return {
    id: payload.safetyCaseHazard.id,
    safetyCaseId: payload.safetyCaseHazard?.safetyCaseId,
    name: safetyCaseHazardValues?.name,
    description: safetyCaseHazardValues?.description,
    selectedRiskMatrixCellId: safetyCaseHazardValues?.selectedRiskMatrixCell?.id,
    riskRationale: safetyCaseHazardValues?.riskMatrixRationale,
    geometry: payload?.geoJson && {
      type: String(payload.geoJson.geometry.type),
      coordinates: JSON.stringify(payload.geoJson.geometry.coordinates),
    },
    sortOrder: safetyCaseHazardValues?.sortOrder,
  }
}
